import { Layout } from '@/components/Layout';
import { ErrorPage } from '@/components/ErrorPage';
import { ReactNode } from 'react';

export function with410(component: ReactNode, pageProps: any) {
  if (pageProps.isGone) {
    return <Layout content={<ErrorPage status={410} />} />;
  }

  return component;
}
